<section class="page">
  @if (toastMessage) {
    <div class="toast" [class.success-toast]="toastType === 'success'" [class.error-toast]="toastType === 'error'">
      {{ toastMessage }}
    </div>
  }

  <h2>Modifier un composant</h2>

  @if (loadingComposants) {
    <p>Chargement des composants...</p>
  }

  <label for="select-composant">Composant</label>
  <select id="select-composant" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
    <option value="">-- sélectionner --</option>
    @for (composant of composants; track composant.id) {
      <option [value]="composant.id">{{ composant.nom }}</option>
    }
  </select>

  @if (!loadingComposants && composants.length === 0) {
    <p class="error">Aucun composant chargé. Rafraîchis la page ou vérifie la connexion API.</p>
  }

  <form (ngSubmit)="submit()">
    <label>Nom *</label>
    <input name="nom" [(ngModel)]="nom" required />

    <label>Lien fournisseur</label>
    <input name="lien" [(ngModel)]="lien" />

    <label>Classe *</label>
    <select name="selectedClasseId" [(ngModel)]="selectedClasseId" required>
      <option value="">-- sélectionner une classe --</option>
      @for (classe of classesComposants; track classe.id) {
        <option [value]="classe.id">{{ classe.nom }}</option>
      }
    </select>

    @if (loadingClasses) {
      <small>Chargement des classes...</small>
    }

    <label>Prix hors taxe et hors frais de livraison (€)</label>
    <input name="prix" [(ngModel)]="prix" type="number" step="0.01" min="0" inputmode="decimal" />
    <small>Format attendu: 12.34 (2 décimales max)</small>

    <label>Standard d'emballage</label>
    <input name="standardEmballage" [(ngModel)]="standardEmballage" maxlength="50" />

    <label>Prix unitaire (€)</label>
    <input type="text" [value]="getPrixUnitaire()" readonly />
    <small>Calculé automatiquement : Prix / Standard d'emballage</small>

    <label>Unité</label>
    <input name="unite" [(ngModel)]="unite" maxlength="3" />
    <small>Maximum 3 caractères (ex: pcs, g, ml)</small>

    <label>Référence fabricant</label>
    <input name="refFabricant" [(ngModel)]="refFabricant" />

    <label>Commentaire</label>
    <textarea name="commentaire" [(ngModel)]="commentaire"></textarea>

    <label>Nouvelle image (optionnel)</label>
    <input type="file" accept=".jpg,.jpeg,.png,.webp,.gif" (change)="onFileChange($event)" />

    @if (imagePreviewToDisplay) {
      <div class="image-preview">
        <span class="image-preview-label">Miniature image composant</span>
        <img [src]="imagePreviewToDisplay" [alt]="nom || 'Image du composant'" />
      </div>
    }

    <button type="submit" [disabled]="loading">Modifier</button>
  </form>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }
</section>
